module.exports = {
    "Clear search": `Rensa s\xf6kning`
};


//# sourceMappingURL=sv-SE.main.js.map
